import { Fragment } from 'react';
import { getActivePageProps } from '../../../../navigation/getActivePageProps';
import { ChevronRightIcon, Responsive } from '../../../../ui';
import { getUrlForPageId } from '../../../../utils/getUrlForLink';
import { NavButton, NavLabel, NavLink, NavListItem } from './NavItem.styles';
import { useCommonData } from '../../../../common-data/useCommonData';
import {
	IMenuItemEntry,
	IOtherWebsitesEntry,
} from '../../../../contentful/types/IMenuItem';
import ChevronDownIcon from '../../../../assets/icons/navigation/chevron-down.svg';
import { useSearchData } from '../../../../common-data/useSearchData';
import { useGetWebsiteDetails } from '../hooks/useSiteSectionDetails';

type INavMenuItemEntry = IMenuItemEntry | IOtherWebsitesEntry;

interface INavItemProps {
	item: INavMenuItemEntry;
	isActive: boolean;
	isSubmenuOpen: boolean;
	onClick: (item: INavMenuItemEntry) => void;
	siteSectionId?: string;
}

export default function NavItem({
	item,
	isSubmenuOpen,
	siteSectionId,
	isActive,
	onClick,
}: INavItemProps) {
	const { isSearchOpen, updateSearchOpen } = useSearchData();
	const { pathToPageIdMap } = useCommonData();
	const isSmallDesktop = Responsive.useMatchesBreakpoint('desktop');
	const { homeUrl } = useGetWebsiteDetails();

	const handleNavItemClick = () => {
		if (isSearchOpen) {
			updateSearchOpen(false);
		}
	};

	return (
		<Fragment key={item.id}>
			<NavListItem
				isActive={isActive}
				open={isSubmenuOpen}
				className="no-max-width"
			>
				{!item.fields.subMenuItems?.length ? (
					<NavLink
						{...getActivePageProps(item, siteSectionId)}
						href={getUrlForPageId(
							item.fields.page?.fields.id || homeUrl,
							pathToPageIdMap,
						)}
						isActive={isActive}
						isSubmenuOpen={isSubmenuOpen}
						onClick={handleNavItemClick}
					>
						<NavLabel>{item.fields.title}</NavLabel>
					</NavLink>
				) : (
					<NavButton
						onClick={() => onClick(item)}
						isActive={isActive}
						isSubmenuOpen={isSubmenuOpen}
					>
						<NavLabel>{item.fields.title}</NavLabel>{' '}
						{isSmallDesktop ? (
							<ChevronRightIcon aria-label="expand" />
						) : (
							<ChevronDownIcon aria-label="expand" />
						)}
					</NavButton>
				)}
			</NavListItem>
		</Fragment>
	);
}
